import React, {useImperativeHandle, useRef, useState} from 'react'
import {IReferralPoint} from '../../../apis/point/getReferralPoint'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import useNavigation from '../../../hooks/useNavigation'
import WizImage from '../../../components/image/WizImage'
import {useImage} from '../../../utils/image'

interface IProps {
    className?: string
}

const PointDueToReferralModal = ({className}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [body, setBody] = useState<IReferralPoint>()
    const {goUserDetail} = useNavigation()
    const {renderThumbnail} = useImage()
    useImperativeHandle(ref, () => ({
        show: data => {
            setBody(data)
            modalRef.current.show()
        },
    }))

    return (
        <>
            <WizModal title={`${body?.user_name}'s Inviters`} className={`max-h-[400px] ${className}`} ref={modalRef}>
                <div>
                    {body?.inviters?.map(item => (
                        <div
                            key={item?.id}
                            onClick={() => {
                                goUserDetail(item?.id)
                            }}
                            className={
                                'border-b border-b-line03 px-[10px] p-[10px] flex items-center gap-x-[10px] cursor-pointer hover:bg-line04'
                            }>
                            <WizImage
                                src={renderThumbnail(item?.thumbnail)}
                                className={'w-[36px] h-[36px] flex-none rounded-full'}
                            />

                            <Text>{item?.name}</Text>
                        </div>
                    ))}
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(PointDueToReferralModal)
